import { useEffect, createContext } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  Button,
  Modal,
  Space,
  Spin,
  Card,
  Row,
  Col,
  Flex,
  Dropdown,
  MenuProps,
} from "antd";

import { DownOutlined } from "@ant-design/icons";

import ObjectForm from "components/Admin/ObjectForm";

import { RootState } from "Redux/store";
import { fetchCon, updateCon, createCon, deleteCon } from "Redux/Admin/DecisionManager/Cons/action";

import { settings, initialSettings, initialValues } from './const';
import { ADMIN_PATH } from "utils/routes";

import type { ICon } from 'Redux/Admin/DecisionManager/Cons/type';

const OptionCon = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { id } = useParams<{ id: string }>();
  const isNew = id === 'new';

  const { entities, loading, error } = useSelector((state: RootState) => state.fetchCons);

  const [modal, contextHolder] = Modal.useModal();

  const ReachableContext = createContext<string | null>(null);

  useEffect(() => {
    if (id && !isNew) {
      dispatch(fetchCon(id));
    }
  }, [dispatch, isNew, id]);

  const onFinish = (values: any) => {
    if (isNew) {
      dispatch(createCon(values, handleCreate));
    }
    else if (id) {
      dispatch(updateCon(values, id));
    }
  };

  const handleCreate = (conject: ICon) => {
    if (conject && conject.id) {
      navigate(`${ADMIN_PATH}/decision-manager/cons/${conject.id}`);
    }
  }

  if (!id) {
    navigate(`${ADMIN_PATH}/decision-manager/cons`, { replace: true });
    return null;
  }

  const con = isNew ? initialValues : entities[id];

  if (!con) {
    return <Spin />;
  }

  const menuItems: MenuProps['items'] = [
    {
      label: 'Delete Con',
      key: '2',
      danger: true,
    }
  ];

  const modalConfig = {
    title: 'Delete the con?',
    content: <span>Are you sure you want to delete the con <b>{con.id}</b>?</span>,
    confirmLoading: true
  };

  const handleMenuClick: MenuProps['onClick'] = async (e) => {
    if (e.key === '2') {
      const confirmed = await modal.confirm(modalConfig);

      if (confirmed) {
        dispatch(deleteCon(id, () => {
          navigate(`${ADMIN_PATH}/decision-manager/cons`, { replace: true });
        }));
      }
    }
  };

  const menuConps = {
    items: menuItems,
    onClick: handleMenuClick,
  };

  return (
    <ReachableContext.Provider value="Light">
      <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <Row>
          <Col span={12}>
            <Flex
              gap="middle"
              align="center"
              justify="space-between"
              style={{ marginBottom: 16 }}
            >
              <Link to={`${ADMIN_PATH}/decision-manager/cons`}>Back</Link>
            </Flex>

            <Card title={`${isNew ? 'Create' : '' } Con`} extra={
              isNew ? null : <Dropdown menu={menuConps} placement="bottom">
                <Button>
                  <Space>
                    Manage Con
                    <DownOutlined />
                  </Space>
                </Button>
              </Dropdown>
            }>
              <ObjectForm
                data={con}
                errorData={error}
                isNew={isNew}
                settings={isNew ? initialSettings : settings}
                loading={loading}
                onFinish={onFinish}
              />
            </Card>
          </Col>
        </Row>
      </div>

      {contextHolder}
    </ReachableContext.Provider>
  );
}

export default OptionCon;
